const authActionTypes = {
  createUser: 'auth/createUser',
  login: 'auth/login',
  loadUser: 'auth/loadUser',
  logout: 'auth/logout',
  resetPassword: 'auth/resetPassword',
};

export default authActionTypes;
